import { connect } from "react-redux";
import Blog from "../../common/Blog";
import { actionCreators } from "../Blog/action";
const mapStateToProps = (state) => {
  const pageData = state.colorTheory && state.colorTheory;
  return { pageData };
};

function mapDispatchToProps(dispatch) {
  const callToData = () =>  dispatch(actionCreators.get('colorTheory'));
  return { callToData };
}

export default connect(mapStateToProps, mapDispatchToProps)(Blog);
